import { CSSObject } from "@emotion/react";

export const contentCss: CSSObject = {
  whiteSpace: "nowrap",
};
